import { render, staticRenderFns } from "./MyPolicy.vue?vue&type=template&id=00dcedf6&scoped=true"
import script from "./MyPolicy.vue?vue&type=script&lang=js"
export * from "./MyPolicy.vue?vue&type=script&lang=js"
import style0 from "./MyPolicy.vue?vue&type=style&index=0&id=00dcedf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dcedf6",
  null
  
)

export default component.exports